import { render, staticRenderFns } from "./UserProtocol.vue?vue&type=template&id=59cc1608&scoped=true"
import script from "./UserProtocol.vue?vue&type=script&lang=js"
export * from "./UserProtocol.vue?vue&type=script&lang=js"
import style0 from "./UserProtocol.vue?vue&type=style&index=0&id=59cc1608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc1608",
  null
  
)

export default component.exports